module.exports = __webpack_public_path__ + "img/Kinetika-BlackItalic.9571f8c6.svg";